import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useServiceRequestLightHelpdeskTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
